import type { LoadstoneAnimation, LoadstoneConfig } from './loadstone-types'

export function getLoadstoneAnimationName(animation: LoadstoneAnimation): string {
  return `loadstone-${animation}`
}

export function getLoadstoneCycleDurationMs(config: Pick<LoadstoneConfig, 'duration'>): number {
  return config.duration
}

export function getLoadstoneStaggerDelayMs(order: number, duration: number, stagger: number): number {
  if (duration <= 0) {
    return 0
  }

  const offset = (((order * stagger) % duration) + duration) % duration
  return offset === 0 ? 0 : offset - duration
}
